import { render, staticRenderFns } from "./RepositoryCreate.vue?vue&type=template&id=1c81f720&"
import script from "./RepositoryCreate.vue?vue&type=script&lang=js&"
export * from "./RepositoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports